export const setIsFlowValid = "FLOW_DESIGNER_VALIDATOR/SET_IS_FLOW_VALID";
export const setErrorsResolved = "FLOW_DESIGNER_VALIDATOR/SET_ERRORS_RESOLVED";
export const setIsErrorModeEnabled = "FLOW_DESIGNER_VALIDATOR/SET_IS_ERROR_MODE_ENABLED";
export const showErrorMessagesBar = "FLOW_DESIGNER_VALIDATOR/SHOW_ERROR_MESSAGES_BAR";
export const removeFixedError = "FLOW_DESIGNER_VALIDATOR/REMOVE_FIXED_ERROR";
export const reset = "FLOW_DESIGNER_VALIDATOR/RESET";
